import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const REPLACEMENT_SPEED = 3000;

const AnalyzingSentences = () => {
  const { t } = useTranslation();
  const [text, setText] = useState<string>('');

  useEffect(() => {
    let isActive = true;

    let sentenceIndex = 0;
    const numberOfSentences: number = Number(t('soundAnalyzingSentences.numberOfSentences')) || 1;
    const sentences: string[] = [];

    for (let i = 0; i < numberOfSentences; i++) {
      sentences.push(t(`soundAnalyzingSentences.${i}`));
    }

    const updateText = () => {
      if (!isActive) {
        return;
      }

      setText(sentences[sentenceIndex]);
      sentenceIndex = (sentenceIndex + 1) % numberOfSentences;
    };

    updateText();

    const timer = setInterval(updateText, REPLACEMENT_SPEED);

    return () => {
      isActive = false;
      clearInterval(timer);
    };
  }, [t]);

  return <>{text}</>;
};

export default AnalyzingSentences;
